/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Novelist API
 * Admin REST API
 * OpenAPI spec version: 1b8b3abca32e2944b8fba3ab2fea012630968b0b
 */

/**
 * Why a billing period cannot be given precedence over the entitlements in its window.
 */
export type PrecedenceRefusal = typeof PrecedenceRefusal[keyof typeof PrecedenceRefusal];


export const PrecedenceRefusal = {
  already_projected: 'already_projected',
  period_expired: 'period_expired',
  blockers_not_started: 'blockers_not_started',
} as const;
